// test196
(196 && 0);
